import { useEffect } from 'react';

export default function usePageTitle(title: string | null) {
  useEffect(() => {
    // Set title in browser tab
    document.title = title ? title + ' -- Protege AI' : 'Protege AI';

    return () => {
      // Reset the title on unmount
      document.title = 'Protege AI';
    };
  }, [title]);
}
